import { TrainingHero } from '@/components/training/TrainingHero'
import { TrainingOfferings } from '@/components/training/TrainingOfferings'

export const TrainingPage = () => (
  <>
    <TrainingHero />

    <TrainingOfferings />
  </>
)
